<script setup lang="ts">
import { computed, nextTick, ref, watch } from "vue";

const props = defineProps<{
  landingPage: boolean;
  videos: any;
  posterImage: any;
}>();

const page = usePage().value;

const displayVideos = computed(() => {
  if (props.landingPage && (props.videos || props.posterImage)) {
    return [
      {
        vimeoUrl: props.videos?.url ?? props.videos,
        posterimage: props.posterImage,
      },
    ];
  }
  return page?.featureVideos ?? [];
});
const showModal = ref(false);
const loadingStates = ref<boolean[]>([]);
const toggleModal = () => {
  showModal.value = !showModal.value;
};
const closeModal = () => {
  showModal.value = false;
};

// Populate playerRefs when component mounts

// Watch for changes in showModal to play/pause the videos
watch(showModal, async (isOpen) => {
  await nextTick(); // Wait for the DOM to update

  const videoEls = document.querySelectorAll("video");
  videoEls.forEach((video, index) => {
    if (isOpen) {
      loadingStates.value[index] = true; // Set loading state to true initially

      // Show loading dots when buffering
      const showLoading = () => {
        loadingStates.value[index] = true;
      };

      // Hide loading dots when video is ready to play
      const hideLoading = () => {
        loadingStates.value[index] = false;
        video.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      };

      video.addEventListener("waiting", showLoading);
      video.addEventListener("canplay", hideLoading);

      // Start loading the video
      video.load();
    } else {
      // Pause and reset video if modal is closed
      video.pause();
      video.currentTime = 0;
      loadingStates.value[index] = false;

      // Clean up event listeners
      video.removeEventListener(
        "waiting",
        () => (loadingStates.value[index] = true),
      );
      video.removeEventListener(
        "canplay",
        () => (loadingStates.value[index] = false),
      );
    }
  });
});
</script>

<template>
  <Teleport to="body">
    <Transition name="pop" appear>
      <div v-if="showModal" v-cloak class="modal video-modal">
        <div v-for="(video, index) in displayVideos" :key="index">
          <div class="video-wrapper">
            <video
              playsinline
              preload="none"
              :poster="video?.posterimage?.url ?? video?.posterimage"
              controls
            >
              <source :src="video?.vimeoUrl" type="video/mp4" />
            </video>
            <AppSVGLoadingDots v-if="loadingStates[Number(index)]" />
          </div>
        </div>
      </div>
    </Transition>
    <Transition name="fade" appear>
      <div v-if="showModal" v-cloak class="backdrop" @click="closeModal"></div>
    </Transition>
  </Teleport>
  <section class="featured-videos-wrap">
    <div v-for="(video, index) in displayVideos" :key="index">
      <Transition name="fade">
        <div
          v-if="video?.posterimage"
          class="video-poster"
          @click.prevent="toggleModal()"
        >
          <div class="play-button">
            <svg viewBox="0 0 24 24">
              <circle
                cx="12"
                cy="12"
                r="10"
                fill="transparent"
                stroke="#FFF"
                stroke-width="1"
              />
              <polygon points="10,8 16,12 10,16" fill="#FFF" />
            </svg>
          </div>
          <NuxtPicture
            v-if="video?.posterimage"
            loading="lazy"
            :src="video?.posterimage?.url ?? video?.posterimage"
            :width="video?.posterimage?.width"
            :height="video?.posterimage?.height"
            :alt="video?.posterimage?.alt"
            sizes="sm:100vw md:50vw lg:800px"
          />
        </div>
      </Transition>
      <!-- <div class="page-vimeo-wrapper">
        <div ref="playerContainer"></div>
        <button @click="playVideo">Play</button>
        <button @click="pauseVideo">Pause</button>
      </div> -->
    </div>
  </section>
</template>
